import { ReactNode } from 'react'
import tw, { TwStyle } from 'twin.macro'

type WrapperProps = {
  children: ReactNode
  twStyle?: TwStyle
}

const styles = {
  container: ({ twStyle }: { twStyle?: TwStyle }) => [
    tw`w-full mx-auto px-0 sm:px-2 md:px-3 lg:px-5 max-w-layout`,
    twStyle
  ]
}

const Wrapper = ({ children, twStyle }: WrapperProps) => {
  return <div css={styles.container({ twStyle })}>{children}</div>
}

export default Wrapper
